import React from 'react';

import FaqCategoryApi from '../../../Api/CRM/Modules/FaqCategoryApi';
import FaqCategory from '../../../Api/Models/FaqCategory';
import useGlobalState from '../../GlobalStateContext';
import ActionButton from '../../elements/ActionButton';
import DeleteButton from '../../elements/DeleteButton';
import EditButton from '../../elements/EditButton';
import ViewButton from '../../elements/ViewButton';
import Card from '../../elements/common/Card';
import TableHead from '../../elements/common/TableHead';
import TableLoader from '../../elements/common/TableLoader';
import Paginator from '../../elements/paginator';
import { PERMISSION } from '../../helpers/Permissions';
import useAutoPaginator from '../../hooks/useAutoPaginator';

function FaqCategoryList() {
    const { languageNames } = useGlobalState();
    const { items, isLoading, updateItems, auto } = useAutoPaginator<FaqCategory>((page, params) =>
        FaqCategoryApi.getAll(page, { params })
    );

    return (
        <Card title="All Faq Categories">
            <ActionButton
                url="/faq_category/create"
                title="Create new faq category"
                permissions={[PERMISSION.CREATE_FAQ_CATEGORY]}
            />
            <TableLoader isLoading={isLoading}>
                <table className="table model-list">
                    <TableHead>
                        <th>Action</th>
                        <th>Name</th>
                        <th>Language</th>
                        <th>Translation of</th>
                    </TableHead>
                    <tbody>
                        {items.map((faqCategory) => (
                            <tr key={faqCategory.id}>
                                <td>
                                    <ViewButton
                                        url={`/faq_category/${faqCategory.id}`}
                                        permissions={[PERMISSION.VIEW_FAQ_CATEGORY]}
                                    />
                                    <EditButton
                                        url={`/faq_category/${faqCategory.id}/edit`}
                                        permissions={[PERMISSION.UPDATE_FAQ_CATEGORY]}
                                    />
                                    <DeleteButton
                                        url={`/crea/api/faq_category/${faqCategory.id}`}
                                        action={updateItems}
                                        permissions={[PERMISSION.DELETE_FAQ_CATEGORY]}
                                    />
                                </td>
                                <td>{faqCategory.name}</td>
                                <td>{languageNames[faqCategory.language_id]}</td>
                                <td>{faqCategory.translation_id}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <Paginator {...auto.paginator} />
            </TableLoader>
        </Card>
    );
}

export default FaqCategoryList;
